// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wb yc","wrapperNeonRental":"wc x3"};